// Elegir un emoji: un boton que ensena el elegido y, al pulsarlo, la rejilla.
//
// Vivia dentro de `ToolStudioFlowPage` con sus tres `<button>` crudos y su
// propia lista de emoji -la cuarta del repositorio-. La lista sale ahora de
// `lib/colores-de-icono`, que es donde ya estaba `EMOJIS_RAPIDOS`.
//
// El elemento crudo se queda aqui, que es donde esta bien: una muestra de emoji
// no es el componente `Button` -lo unico que ensena es el emoji- pero si es un
// boton: se pulsa y responde al teclado.

import * as React from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { EMOJIS_RAPIDOS } from '@/lib/colores-de-icono'
import { cn } from '@/lib/utils'

export function SelectorDeEmoji({
  emoji,
  onElegir,
  etiqueta = 'Elegir emoji',
}: {
  emoji: string
  onElegir: (em: string) => void
  etiqueta?: string
}) {
  const [abierto, setAbierto] = React.useState(false)
  const [propio, setPropio] = React.useState('')

  return (
    <Popover open={abierto} onOpenChange={setAbierto}>
      <PopoverTrigger asChild>
        <button
          type="button"
          title={etiqueta}
          aria-label={etiqueta}
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border-2 border-dashed border-border bg-muted/40 text-2xl transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          {emoji || <span className="text-xs text-muted-foreground">icono</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-4" align="start" sideOffset={8}>
        <div className="grid grid-cols-8 gap-2">
          {EMOJIS_RAPIDOS.map((em) => (
            <button
              key={em}
              type="button"
              onClick={() => { onElegir(em); setAbierto(false) }}
              className={cn(
                'flex h-8 w-8 items-center justify-center rounded-md text-lg hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                emoji === em && 'bg-primary/15',
              )}
            >
              {em}
            </button>
          ))}
        </div>
        <div className="mt-4 flex items-center gap-2">
          <Input
            value={propio}
            onChange={(e) => setPropio(e.target.value)}
            placeholder="Pega un emoji"
          />
          <Button
            size="xs"
            variant="secondary"
            className="shrink-0"
            onClick={() => {
              if (!propio.trim()) return
              onElegir(propio.trim())
              setPropio('')
              setAbierto(false)
            }}
          >
            Usar
          </Button>
        </div>
        {emoji && (
          <Button
            variant="ghost"
            size="xs"
            className="mt-2 w-full text-muted-foreground"
            onClick={() => { onElegir(''); setAbierto(false) }}
          >
            Quitar emoji
          </Button>
        )}
      </PopoverContent>
    </Popover>
  )
}
